import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/compensation/messages";
import { camelizeKeys } from "lib/helpers";

function* getLedgerCsv(action) {
  const params = {
    ...action.payload,
    csv: true,
  };
  const { success, data, error } = yield* makeRequest.get("/compensation/ledger", params);

  if (success && data) {
    yield put(actions.setLedgerCsv(camelizeKeys(data.body.csv)));
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_LEDGER_CSV,
    });
  }

  return null;
}

export default getLedgerCsv;
